'use strict'

/**
 *
 * @name: addonSlideshow
 *
 */

import DirectiveTemplate from './nn-addon-slideshow.directive.html'
import './nn-addon-slideshow.directive.scss'
import _get from 'lodash.get'

function AddonSlideshowDirective() {

  'ngInject'

  return {
    restrict: 'C',
    replace: true,
    scope: {
      post: '=*',
      mediaKey: '=*'
    },
    template: DirectiveTemplate,
    link: function(scope, element, attrs) {


      /*
       *
       * @CONFIG
       *
       */

      scope.slideshowSettings = {
        item: null,
        images: []
      }

      scope.swiperOptions = {
        spaceBetween: 0,
        speed: 300,
        loop: true,
        slidesPerView: 1,
      }

      scope.aspectRatio = _get(scope, '$root.post.id') === 8208 ? 1 : 0.66

      /*
       *
       * @PUBLIC
       *
       */


      /*
       *
       * @PRIVATE
       *
       */


      function _init () {
        scope.post.media.forEach(item => {
          if (item.key === attrs.mediaKey) {
            scope.slideshowSettings.images.push(item)
          }
        })
      }


      /*
       *
       * @INIT
       *
       */

      _init()

    }
  }
}

export default AddonSlideshowDirective



// WEBPACK FOOTER //
// ./app/components/nn-add-ons/nn-addon-slideshow/nn-addon-slideshow.directive.js